import {EApproveStatus} from 'src/containers/MessageMatchers/definitions';
import {
  ENotificationLevel,
  EWebNotificationSection,
  EWebNotificationType,
} from 'src/containers/Notifications';

import {ECategory} from './definitions';

export default {
  today: 'Today',
  yesterday: 'Yesterday',
  previously: 'Previously',
  client_one: '<b>{{count}}</b> client',
  client_other: '<b>{{count}}</b> clients',
  filters: {
    labels: 'Status',
    notificationCategory: 'Notification type',
    broadcasts: 'Broadcast name',
    uploadCategory: 'Download type',
    initiator: 'Download initiator',
  },
  level: {
    [ENotificationLevel.SUCCESS]: 'Success',
    [ENotificationLevel.WARNING]: 'Attention required',
    [ENotificationLevel.ERROR]: 'Error',
    [ENotificationLevel.LOADING]: 'Loading',
  },
  category: {
    [ECategory.SUBSCRIBERS_UPLOAD]: 'Audience list',
    [ECategory.BROADCAST_LIFECYCLE]: 'Broadcast status',
    [ECategory.LICENSE]: 'License',
    [ECategory.CALLBACK_LIFECYCLE]: 'Webhooks',
    [ECategory.APIKEY_USER_LIFECYCLE]: 'API key',
    [ECategory.TENANT_DETAILS_UPDATES]: 'Details',
    [ECategory.TARIFF_ACCEPTANCE]: 'Pricing accepted',
    [ECategory.MESSAGE_REPORT]: 'Message report',
  },
  tabs: {
    [EWebNotificationSection.NOTIFICATIONS]: 'Notifications',
    [EWebNotificationSection.UPLOADS]: 'Downloads',
  },
  message: {
    [EWebNotificationType.SubscribersUploadLoading]:
      'Uploading client list {{fileName}}. <0>Check the progress</0>',
    [EWebNotificationType.SubscribersUploadFailed]: `Client list upload was interrupted. The list of the clients {{fileName}} has not been uploaded`,
    [EWebNotificationType.SubscribersUploadPartial]:
      'The client list {{fileName}} has been partially loaded. <0>Check the result</0>',
    [EWebNotificationType.SubscribersUploadSuccess]: `The client list {{fileName}} has been successfully loaded. <0>Check the result</0>`,
    [EWebNotificationType.BroadcastCompleted]: `The broadcast "{{name}}" is completed. <0>To the broadcast report</0>`,
    [EWebNotificationType.BroadcastCancelled]: `The broadcast "{{name}}" has been stopped. <0>To the broadcast report</0>`,
    [EWebNotificationType.LicenseExpiring]:
      'Your edna Pulse license expires on {{date}}. To extend it, pay for the services.',
    [EWebNotificationType.CallbackUpdated]: `The webhook URL has been updated successfully. Go to <0>Integration → Settings</0>`,
    [EWebNotificationType.ApikeyUserUpdated]: `The API key has been updated successfully. Go to <0>Integration → Settings</0>`,
    [EWebNotificationType.CompanyDetailsUpdated]: `User "{{login}}" has changed the company details. <0>To details</0>`,
    [EWebNotificationType.PaymentDetailsUpdated]: `User "{{login}}" has changed the company payment details. <0>To details</0>`,
    [EWebNotificationType.TenantTariffAccepted]: `User "{{login}}" has agreed to the available pricing options. <0>To tariffs</0>`,
    [EWebNotificationType.AgreedChangeTariffRequest]: `User "{{login}}" has accepted the pricing changes for <b>{{tariffName}}</b>. <0>To pricing</0>`,
    [EWebNotificationType.NotAgreedChangeTariffRequest]: `User "{{login}}" has rejected the pricing changes for <b>{{tariffName}}</b>. <0>To tariffs</0>`,
    [EWebNotificationType.JivoEnabled]:
      'User {{login}} has connected all the WhatsApp channel traffic to the Jivo chat platform',
    [EWebNotificationType.JivoDisabled]:
      'User {{login}} has disconnected all the WhatsApp channel traffic to the Jivo chat platform',
    [EWebNotificationType.MessageMatcherStatusChanged]: {
      [EApproveStatus.DISABLED]:
        'Template "{{name}}" was disabled. All scheduled broadcasts using this template are stopped.',
      [EApproveStatus.PAUSED]:
        'Template "{{name}}" was paused. All scheduled broadcasts using this template are stopped.',
      [EApproveStatus.APPROVED]: 'Template "{{name}}" status changed. New status: Active.',
      [EApproveStatus.REJECTED]: 'Template "{{name}}" status changed. New status: Rejected.',
      [EApproveStatus.PENDING]:
        'Template "{{name}}" status changed. New status: Pending registration.',
      [EApproveStatus.NOT_SENT]: 'Template "{{name}}" status changed. New status: Draft.',
      [EApproveStatus.ARCHIVED]: 'Template "{{name}}" status changed. New status: Archived.',
    },
    [EWebNotificationType.MessageMatcherCategoryChanged]: `The category of WhatsApp template "{{name}}" was changed by WhatsApp. New category: "{{newCategory}}".`,
    [EWebNotificationType.ChannelProfilePartnerProfileCreated]:
      'Select the channel pricing for the WhatsApp account "{{name}}" to complete the registration.',
    [EWebNotificationType.ChannelProfileQualityScoreChanged]:
      'WhatsApp Business API {{name}}: quality changed. New quality: {{qualityScore}}.',
    [EWebNotificationType.ChannelProfileMessagingLimitChanged]:
      'WhatsApp Business API {{name}}: limit changed. New limit: {{messagingLimit}}.',
    [EWebNotificationType.ChannelProfileQualityStatusChanged]:
      'WhatsApp account {{name}} status changed. New status: {{qualityStatus}}.',
    [EWebNotificationType.ChannelProfileWABAViolation]:
      'WhatsApp Business account {{wabaId}} is violating the WhatsApp Business Terms of Service. The reason is {{violationType}}. The following channels may be restricted or disabled: {{channels}}. We recommend that you <0>follow the recommendations</0>.',
    [EWebNotificationType.ChannelProfileWABARestriction]:
      'WhatsApp Business account {{wabaId}} has been restricted due to activity that violates the WhatsApp Business Terms of Service. The following channels are restricted until {{expirationDate}} and can only receive incoming messages: {{channels}}. To submit an appeal, <0>follow the recommendations</0>.',
    [EWebNotificationType.ChannelProfileWABADisable]:
      'WhatsApp Business account {{wabaId}} has been disabled due to activity that violates the WhatsApp Business Terms of Service. The following channels have stopped working: {{channels}}. You cannot register new channels with this WhatsApp Business account. To submit an appeal, <0>follow the recommendations</0>.',
    [EWebNotificationType.ChannelProfileWABAReinstate]:
      'WhatsApp Business account {{wabaId}} has been restored. The following channels become active again: {{channels}}.',
    [EWebNotificationType.MessageReportLoading]: 'The report {{name}} is being generated',
    [EWebNotificationType.MessageReportSuccess]:
      'The report {{name}} has been generated. <0>Download</0>',
    [EWebNotificationType.MessageReportFailed]: '{{name}} report generation has been cancelled',
    [EWebNotificationType.FlowMessageReportLoading]: 'Generating a report on the {{name}} script',
    [EWebNotificationType.FlowMessageReportSuccess]:
      'The report {{name}} has been generated. <0>Download</0>',
    [EWebNotificationType.FlowMessageReportFailed]: '{{name}} report generation has been cancelled',
    [EWebNotificationType.ChannelProfileMaxBotRegistration]:
      'Channel "{{name}}" sent for registration. View <0>channel</0>',
    [EWebNotificationType.ChannelProfileMaxBotSubjectCreated]:
      'Channel "{{name}}" registered. View <0>channel</0>',
    [EWebNotificationType.ChannelProfileMaxConnected]:
      'Channel "{{name}}" connected. View <0>channel</0>',
    [EWebNotificationType.ChannelProfileMaxDisconnected]:
      'Channel "{{name}}" disconnected. View <0>channel</0>',
    [EWebNotificationType.ChannelProfileTelegramConnected]:
      'Channel "{{name}}" connected. View <0>channel</0>',
    [EWebNotificationType.ChannelProfileTelegramDisconnected]:
      'Channel "{{name}}" disconnected. View <0>channel</0>',
  },
  notFound: {
    title: "Sorry, we didn't find anything",
    button: 'Try again',
    [EWebNotificationSection.NOTIFICATIONS]: 'There are no notifications for the selected filters',
    [EWebNotificationSection.UPLOADS]: 'No downloads based on selected filters',
  },
  noData: {
    title: 'Nothing here for the selected period',
  },
  errors: {
    messageReportNotExist: 'File not found. Try generating again',
  },
};
